module.exports = require("moment");


//////////////////
// WEBPACK FOOTER
// external "moment"
// module id = 7
// module chunks = 0